import router from "../../router";

export default {
    setAppConfig(state, data) {
        state.appConfig = data.appConfigData;
        localStorage.setItem('appConfig', JSON.stringify(data.appConfigData));
        if (data && data.path && data.path.path) {
            router.push(data.path.path);
        } else {
            router.push("/");
        }
    },

    menu_get_success(state, menuItems) {
        state.menuItems = menuItems
    },
    menu_get_error(state) {
        state.menuItems = []
    },
    company_sites_get_success(state, companySites) {
        state.companySites = companySites
    },
    appointment_status_get_success(state, appointmentStatus) {
        state.appointmentStatus = appointmentStatus;
    },
    addSelectedCompanySite(state, companySite) {
        state.selectedCompanySite = companySite
    },
    company_sites_get_error(state) {
        state.companySites = []
    },
    openChat(state) {
        state.chat = true;
        state.appointments = false;
    },
    openAppointments(state) {
        state.chat = false;
        state.appointments = true;
    },
    closeBoth(state) {
        state.chat = false;
        state.appointments = false;
    },
    changeDefaultColorState(state, color) {
        state.defaultColor = color;
    },
    changeAppointmentsDate(state, date) {
        state.appointmentsDate = date;
    },
    changePatientSelect(state, bool) {
        state.patientSelect = bool;
    },
    setUnreadedMessageCount(state, number) {
        state.unreadedMessageCount = number;
    },
    setExternalAppointmentCount(state, number) {
        state.externalAppointmentCount = number;
    },
    setEnvProfile(state, envProfile) {
        state.envProfile = envProfile;
    }
}
